import { render, staticRenderFns } from "./TeamsFolder.vue?vue&type=template&id=5579d3d9&"
import script from "./TeamsFolder.vue?vue&type=script&lang=js&"
export * from "./TeamsFolder.vue?vue&type=script&lang=js&"
import style0 from "./TeamsFolder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports